import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import ENV from 'lumen/config/environment';
import type MarketCustomReportingExploreRoute from 'lumen/routes/market/custom-reporting/explore';
import type AjaxService from 'lumen/services/ajax';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import type { ModelFrom } from 'lumen/utils/routes';

type LookerMessageData = {
  id: string;
};

export default class MarketCustomReportingExploreController extends Controller {
  declare model: ModelFrom<MarketCustomReportingExploreRoute>;

  @service declare ajax: AjaxService;
  // eslint-disable-next-line ember/no-unused-services
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;
  @service declare router: Services['router'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get embedDomain() {
    return ENV.isDevelopmentOrTest ? 'http://localhost:4200' : this.ajax.host;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get timezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  @action onMessage(type: string, data: LookerMessageData): void {
    // Since users can create a dashboard from the explore page,
    // we need to redirect them to the dashboard edit page
    if (type === 'dashboard:loaded') {
      this.router.transitionTo(
        'market.custom-reporting.dashboard.edit',
        data.id,
      );
    }
  }
}
